"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Card_1 = require("../../molecules/card/Card");
const utils_1 = require("../../molecules/utils");
const typography_1 = require("../../shared/typography");
const renderRating = ({ comment, dateTime, rating, id }) => {
    return ((0, jsx_runtime_1.jsx)(RatingCard, { header: (0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)(utils_1.RatingStars, { rate: rating }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: dateTime }, void 0)] }, void 0), children: comment ? (0, jsx_runtime_1.jsx)("h4", { children: comment }, void 0) : null }, id));
};
const RatingCard = (0, styled_components_1.default)(Card_1.Card) `
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    border-left: none;
    border-right: none;
  }
`;
exports.default = ({ ratings, className, translations }) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { className: className, children: ratings.length ? ((0, jsx_runtime_1.jsx)("ul", { children: ratings.map(renderRating) }, void 0)) : ((0, jsx_runtime_1.jsxs)(NoRatings, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: translations.title }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: translations.subTitle }, void 0)] }, void 0)) }, void 0));
};
const Wrapper = styled_components_1.default.div `
  & {
    flex: 1;
  }

  ul {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  ul > div {
    background-color: ${({ theme }) => theme.colors.whiteBase};
  }

  ul > div:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacings.xs};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    ul {
      width: 100%;
    }
  }
`;
const Header = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;

  & > h4 {
    color: ${({ theme }) => theme.colors.greyLighten70};
    font-weight: 300;

    @media (max-width: 1024px) {
      font-size: 14px;
    }
  }
`;
const NoRatings = styled_components_1.default.div `
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => `0 ${theme.spacings.m}`};
  }
`;
//# sourceMappingURL=List.js.map